import type { ReactNode } from 'react';
import Button from '../ui/Button';

interface BlurPreviewProps {
  children: ReactNode;
  locked: boolean;
  label?: string;
  fakeContent?: ReactNode;
}

export default function BlurPreview({
  children,
  locked,
  label = '🔒 Premium',
  fakeContent,
}: BlurPreviewProps) {
  if (!locked) {
    return <>{children}</>;
  }

  return (
    <div className="relative">
      <div className="blur-[8px] pointer-events-none select-none" aria-hidden>
        {fakeContent ?? (
          <div className="card p-5">
            <div className="h-4 w-40 bg-slate-700/60 rounded mb-4" />
            <div className="h-24 bg-slate-800/70 rounded-xl" />
          </div>
        )}
      </div>

      <div className="absolute inset-0 flex items-center justify-center bg-slate-950/45 rounded-2xl">
        <div className="text-center px-4">
          <p className="text-sm font-semibold text-white mb-3">{label}</p>
          <a href="/settings">
            <Button size="sm">Passa a Premium</Button>
          </a>
        </div>
      </div>
    </div>
  );
}